import { Dockyard } from "./Dockyard";
import { Media } from "./Media";
import { PreparationOrder } from "./PreparationOrder";
import { ShippingFile } from "./ShippingFile";
import { ShippingRecord } from "./ShippingRecord";
import { Warehouse } from "./Warehouse";

export enum ShippingRecordDisputeType {
  SHIPPING_RECORD = "SHIPPING_RECORD",
  PREPARATION_ORDER = "PREPARATION_ORDER",
  DELIVERY = "DELIVERY",
}

export type ShippingRecordDispute = {
  id?: string;
  type: ShippingRecordDisputeType | null;
  linkedEntityId: string;
  linkedEntity?: Warehouse | Dockyard | PreparationOrder | ShippingRecord;
  text: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  createdBy?: string;
  createdById?: string;
  updatedBy?: string;
  updatedById?: string;
  closedBy?: string;
  closedById?: string;
  shippingRecordId: string;
  closedAt: Date | string | null;
  media?: Media[];
  files?: ShippingFile[];

  _count?: {
    files?: number;
  };
};
